module.exports = __webpack_public_path__ + "static/media/4.de65e9db.jpg";